module.exports = __webpack_public_path__ + "static/media/android_logo.09f2d029.png";